import { render, staticRenderFns } from "./View-Reason.vue?vue&type=template&id=8f8a22ec&scoped=true"
import script from "./View-Reason.vue?vue&type=script&lang=js"
export * from "./View-Reason.vue?vue&type=script&lang=js"
import style0 from "./View-Reason.vue?vue&type=style&index=0&id=8f8a22ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8a22ec",
  null
  
)

export default component.exports